import React,  { Component } from 'react';
import PropTypes from 'prop-types';
import { format, parseISO } from 'date-fns';

import Highcharts, { chart } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsExporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import analysisDataHelper from '../data/analysisDataHelper';

import componentStyles from './BarGraph.module.scss';

HighchartsMore(Highcharts);
HighchartsExporting(Highcharts);
OfflineExporting(Highcharts);

class FABarGraph extends Component {

  getBarGraphData() {

    const chartData = this.props.scenarios.map((scenario, index) => {
      const unmodData = scenario.data[this.props.dataField]['yearly_data'];
      const modData = unmodData.map((d) => {
        const dateObj = new Date(d[0]).getTime()
        return [dateObj, d[1]];
      });

      return {
          name: "#" + scenario['Index'],
          data: [...modData],
          color: this.getColorOptions(index),
          marker: {
              enabled: false
          },
      }
    });

    return chartData;
  }

  getColorOptions(index) {
      var colors = Highcharts.getOptions().colors; // this only gives us 10 colors, boo!
      if (index > 9) {
          var randomColor = "#" + Math.floor(Math.random()*16777215).toString(16);
          colors.push(randomColor);
      }
      var perShapeGradient = {
          x1 : 0,
          y1 : 0,
          x2 : 1,
          y2 : 0,
      };
      const myStopColour = new Highcharts.Color(colors[index]);
      // return {
      //     linearGradient : perShapeGradient,
      //     stops : [[0, colors[index]], [1, Highcharts.Color(colors[index]).brighten(0.3).get('rgb')]]
      // };
      return {
        linearGradient : perShapeGradient,
        stops : [[0, colors[index]], [1, myStopColour.brighten(0.3).get('rgb')]]
      };
  }

  getUnits() {
      return this.props.scenarios[0].data[this.props.dataField].units;
  }

  getTitle() {
      var fullDescription = this.props.scenarios[0].data[this.props.dataField].fullDescription || this.props.dataField;
      var units = this.getUnits();
      if (fullDescription && units) {
          return [fullDescription, units].join(' - ');
      }
      return fullDescription;
  }

  getChartOptions() {
    return {
      chart : {
        type : 'column',
        zoomType : 'x',
        spacingRight : 20,
      },
      credits: {
        enabled: false
      },
      title : {
        text : this.getTitle()
      },
      rangeSelector : {
        selected : 3
      },
      legend : {
        enabled : true
      },
      plotOptions: {
        series: {
          pointWidth: 1,
          pointPlacement: 'between',
        }
      },
      xAxis : {
        enabled : true,
        maxZoom : 2,
        title : {
          text : "Date",
        },  
        type: "datetime",
        labels: {
          allowOverlap: false,
          // format: '${value: %Y-%m-%d}',
          formatter: function() {
            // console.log(this);
            const myDate = new Date(this.value);
            const strDate = format(myDate, 'MMM-yyyy');
            // console.log('Formatted Date', strDate);
            return strDate;
            // return Highcharts.dateFormat('%b-%Y', this.value);
          }
        },
      },
      yAxis : {
        title : {
          text : this.getTitle()
        }
      },
      tooltip : {
        headerFormat : '<span style="font-size:10px;font-weight:bold">{point.x: %e %B, %Y}</span><table>',
        pointFormat : '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.1f} ' + this.getUnits() + '</b></td></tr>',
        footerFormat : '</table>',
        shared : true,
        useHTML : true,
        valueDecimals : 2
      },
      series: this.getBarGraphData(),
      exporting: {
        enabled: true, // Enable the export button
        fallbackToExportServer: false, // Crucial for true offline export
        libURL: 'https://code.highcharts.com/modules/offline-exporting/', // Default libURL, adjust if hosting locally
        // Optionally, set higher resolution for exports
        // sourceWidth: 1200,
        // sourceHeight: 800,
        // scale: 2 // PNG will be 2400x1600
        buttons: {
          contextButton: {
            menuItems: [
              // Keep other desired export options
              'downloadPNG',
              'downloadJPEG',
              'downloadSVG',
              // 'separator', // Optional separator
              'downloadCSV',
              'downloadXLS',
              // 'downloadPDF' - Remove or comment this line to remove the PDF button
              'viewData'
            ]
          }
        },
      }
    }
  }

  render() {
    const chartOptions = this.getChartOptions();
    return (
      <div className={componentStyles.barGraph}>

        <div className={componentStyles.graphContainer}>
          <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
            constructorType={ 'chart' }
          />
        </div>

      </div>  
    )
  }
}

FABarGraph.propTypes = {
  scenarios: PropTypes.arrayOf(PropTypes.object),
  dataField: PropTypes.string,
};

export default FABarGraph;
